import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import reducers from '../reducers';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import analytics from './analyticsMiddleware';
import redirectTo from './redirectMiddleware';
import { persistStore } from 'redux-persist';

export default (state = {}, history) => {
  const middleware = applyMiddleware(
    thunk,
    promise,
    analytics,
    redirectTo,
    routerMiddleware(history)
  );

  const createStoreWithMiddleware = compose(
    middleware,
    typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : f => f
  );
  const store = createStoreWithMiddleware(createStore)(reducers, state);
  store.presistor = persistStore(store);
  return store;
};
